import { Route, Routes, useLocation, useNavigate } from "react-router-dom";
import { routes } from "./routes";
import { AppLayout } from "./components/AppLayout/AppLayout";
import { useEffect } from "react";
import { useAppDispatch } from "./store";
import { fetchGuides } from "./store/slices/guides";
import { Tooltip } from "react-tooltip";
import { ToastContainer } from "react-toastify";
import { getPublicKey, subscribe, unsubscribe } from "./api/push";
import { UserRole } from "./api/auth/types";
import { PricingPage } from "./pages/PricingPage";

function App() {
  const navigate = useNavigate();
  const location = useLocation();
  const dispatch = useAppDispatch();
  const token = localStorage.getItem("token");
  const role = localStorage.getItem("role");

  useEffect(() => {
    // Публичные страницы, которые не требуют авторизации
    const publicPages = ["/login", "/pricing"];
    const isPublicPage = publicPages.includes(location.pathname);

    if (!token && !isPublicPage) {
      navigate("/login");
    } else if (token) {
      dispatch(
        fetchGuides([
          "Grade",
          "Country",
          "JobFormat",
          "JobWorkload",
          "AttractionPeriod",
          "ApplicationStatus",
          "VacancyStatus",
          "Skill",
          "CandidateSource",
          "Town",
          "BusinessArea",
          "ProjectStatus",
          "Sex",
          "Currency",
          "LegalEntity",
          "ProjectFormat",
          "ApplicationProfile",
          "CandidateStatus",
          "LeadStatus",
          "LeadSource",
        ]),
      );
    }
  }, [token, navigate, dispatch, location.pathname]);

  useEffect(() => {
    if (location.pathname !== "/") return;
    if (!role) return;
    if (location.pathname === "/") {
      navigate(role === UserRole.ADMIN || role === UserRole.HRD ? "/departments" : "/my-department");
    }
    navigate(role === UserRole.ADMIN || role === UserRole.HRD ? "/departments" : "/my-department");
  }, [location.pathname, navigate, role]);

  useEffect(() => {
    async function subscribeToPush() {
      if (!("serviceWorker" in navigator) || !("PushManager" in window)) return;

      try {
        const permission = await Notification.requestPermission();

        const registration = await navigator.serviceWorker.register("/sw.js");
        let subscription = await registration.pushManager.getSubscription();

        // === ОТПИСКА ===
        if (permission !== "granted") {
          // Отправляем на сервер запрос на отписку
          const endpoint = subscription?.endpoint || localStorage.getItem("pushEndpoint");
          if (endpoint) {
            await unsubscribe({ endpoint });

            localStorage.removeItem("pushEndpoint");
            localStorage.removeItem("pushSubscribed");
          }
          return;
        }

        // === ПОДПИСКА ===
        if (permission === "granted") {
          if (localStorage.getItem("pushSubscribed") === "true") return;

          const { data: publicKey } = await getPublicKey();

          if (!subscription) {
            subscription = await registration.pushManager.subscribe({
              userVisibleOnly: true,
              applicationServerKey: urlBase64ToUint8Array(publicKey),
            });
          }

          const { endpoint, keys } = subscription.toJSON();
          await subscribe({
            endpoint,
            p256dh_key: keys.p256dh,
            auth_key: keys.auth,
          });

          localStorage.setItem("pushSubscribed", "true");
          localStorage.setItem("pushEndpoint", endpoint);
        }
      } catch (e) {
        console.error("Push subscription error", e);
      }
    }

    function urlBase64ToUint8Array(base64String) {
      const padding = "=".repeat((4 - (base64String.length % 4)) % 4);
      const base64 = (base64String + padding).replace(/-/g, "+").replace(/_/g, "/");
      const rawData = window.atob(base64);
      const outputArray = new Uint8Array(rawData.length);
      for (let i = 0; i < rawData.length; ++i) {
        outputArray[i] = rawData.charCodeAt(i);
      }
      return outputArray;
    }

    subscribeToPush();
  }, []);

  return (
    <>
      <Routes>
        {/* Публичные страницы */}
        <Route path="/pricing" element={<PricingPage />} />

        {/* Приватные страницы с авторизацией */}
        <Route path="/" element={<AppLayout />}>
          {routes.map((route) => {
            const { path, Component } = route;
            return <Route key={path} path={path} Component={Component} />;
          })}
        </Route>
      </Routes>
      <Tooltip
        className="tooltip"
        clickable={true}
        globalCloseEvents={{ scroll: true }}
        closeEvents={{ mouseleave: true }}
        id="tooltip"
        delayShow={500}
        style={{
          background: "#343B4C",
          fontSize: "14px",
          lineHeight: "18px",
          padding: "16px 20px",
          borderRadius: "8px",
          zIndex: 4,
          maxWidth: "700px",
        }}
        place="top-start"
        opacity={1}
        classNameArrow="tooltip_arrow"
      />
      <ToastContainer />
    </>
  );
}

export default App;
